import "./Footer.css";

function Footer() {
  return <footer className="app_footer">© Daniel's Wine Shop 2025</footer>;
}

export default Footer;
